import { point, add, subtract, limit } from "../Cropper/point";
function calculateViewportLimit(imageSize, viewportSize) {
  const innerPad = point((viewportSize.width - imageSize.width) / 2, (viewportSize.height - imageSize.height) / 2);
  return {
    min: point(imageSize.width < viewportSize.width ? innerPad.x : -(imageSize.width - viewportSize.width), imageSize.height < viewportSize.height ? innerPad.y : -(imageSize.height - viewportSize.height)),
    max: point(imageSize.width < viewportSize.width ? innerPad.x : 0, imageSize.height < viewportSize.height ? innerPad.y : 0)
  };
}
function recalculateState(state) {
  const {
    isZoomedIn,
    viewportSize = {},
    originalImageSize = {}
  } = state;
  const imageSize = {
    width: isZoomedIn ? originalImageSize.width : viewportSize.aspectRatio < originalImageSize.aspectRatio ? viewportSize.width : viewportSize.height * originalImageSize.aspectRatio,
    height: isZoomedIn ? originalImageSize.height : viewportSize.aspectRatio < originalImageSize.aspectRatio ? viewportSize.width / originalImageSize.aspectRatio : viewportSize.height
  };
  const viewportLimit = calculateViewportLimit(imageSize, viewportSize);
  return {
    ...state,
    viewportLimit,
    scale: isZoomedIn ? 1 : imageSize.width / originalImageSize.width,
    position: limit(viewportLimit.min, viewportLimit.max, state.position)
  };
}
function containView(viewportSize, originalImageSize) {
  const imageSize = {
    width: viewportSize.aspectRatio < originalImageSize.aspectRatio ? viewportSize.width : viewportSize.height * originalImageSize.aspectRatio,
    height: viewportSize.aspectRatio < originalImageSize.aspectRatio ? viewportSize.width / originalImageSize.aspectRatio : viewportSize.height
  };
  const scale = imageSize.width / originalImageSize.width;
  const position = {
    x: (viewportSize.width - imageSize.width) / 2,
    y: (viewportSize.height - imageSize.height) / 2
  };
  const viewportLimit = calculateViewportLimit(imageSize, viewportSize);
  return {
    imageSize: originalImageSize,
    viewportLimit,
    scale,
    position
  };
}
function toggleZoom(state, action) {
  const {
    isZoomedIn: prevIsZoomedIn,
    position: prevPosition,
    scale: prevScale,
    imageSize: prevImageSize,
    viewportSize = {},
    originalImageSize = {}
  } = state;
  const isZoomedIn = !prevIsZoomedIn;
  const {
    point
  } = action;
  if (!isZoomedIn) {
    return {
      ...state,
      isZoomedIn,
      ...containView(viewportSize, originalImageSize)
    };
  }
  const imageSize = {
    width: originalImageSize.width,
    height: originalImageSize.height
  };
  const pointOnImgeRatio = {
    x: (point.x - prevPosition.x) / (prevImageSize.width * prevScale),
    y: (point.y - prevPosition.y) / (prevImageSize.height * prevScale)
  };
  const position = {
    x: point.x - imageSize.width * pointOnImgeRatio.x,
    y: point.y - imageSize.height * pointOnImgeRatio.y
  };
  const viewportLimit = calculateViewportLimit(imageSize, viewportSize);
  return {
    ...state,
    position: limit(viewportLimit.min, viewportLimit.max, position),
    isZoomedIn,
    viewportLimit,
    scale: 1
  };
}
const handlers = {
  LOADED: (state, action) => {
    const {
      viewportSize
    } = state;
    const originalImageSize = {
      width: action.imageSize.width,
      height: action.imageSize.height,
      aspectRatio: action.imageSize.width / action.imageSize.height
    };
    return {
      ...state,
      originalImageSize,
      ...containView(viewportSize, originalImageSize),
      isLoaded: true
    };
  },
  VIEWPORT_SIZE_CHANGED: (state, action) => {
    const newState = {
      ...state,
      viewportSize: {
        width: action.viewportSize.width,
        height: action.viewportSize.height,
        aspectRatio: action.viewportSize.width / action.viewportSize.height
      }
    };
    return recalculateState(newState);
  },
  MOVE_STARTED: (state, action) => {
    return {
      ...state,
      movePreviousPoint: action.point
    };
  },
  MOVE: (state, action) => {
    return {
      ...state,
      isInMove: true,
      movePreviousPoint: action.point,
      position: limit(subtract(state.viewportLimit.min, 50), add(state.viewportLimit.max, 50), point(state.position.x + (action.point.x - state.movePreviousPoint.x), state.position.y + (action.point.y - state.movePreviousPoint.y)))
    };
  },
  MOVE_ENDED: state => {
    return {
      ...state,
      isInMove: false,
      position: limit(state.viewportLimit.min, state.viewportLimit.max, state.position)
    };
  },
  TOGGLE_ZOOM: toggleZoom
};
const reducer = (state, action) => handlers[action.type] ? handlers[action.type](state, action) : state;
export default reducer;
//# sourceMappingURL=reducer.js.map